import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { CustomPercentagePipe } from '@pipes/custom-percentage.pipe';
import { TrendIndicatorComponent } from 'ngx-lib';

type DashboardStatType = 'currency' | 'customPercentage' | 'none';
@Component({
    selector: 'app-dashboard-stat',
    templateUrl: './dashboard-stat.component.html',
    styleUrls: ['./dashboard-stat.component.scss'],
    imports: [CommonModule, CustomPercentagePipe, TrendIndicatorComponent]
})
export class DashboardStatComponent {
    readonly title = input('');
    readonly previousValue = input<number | undefined>(0);
    readonly currentValue = input<number | undefined>(0);
    readonly type = input<DashboardStatType | undefined>('none');
}
